import PayrollSummary from './PayrollSummary';

export default PayrollSummary;
